import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type CustomerAccountsStorefrontDisplayFlatTeamSettingGroupId =
  | "customer_accounts_storefront_display.save_for_later"
  | "customer_accounts_storefront_display.native_accounts";

const groupOwner: SettingOwner = {
  kind: "teamSettings",
  product: "fulfillment",
};

const groupRisk: SettingRisk = {
  level: "low",
  reason:
    "Storefront customer-account settings including native accounts, ad blocks, and integrations.",
};

export const CustomerAccountsStorefrontDisplayFlatTeamSettingGroups = [
  {
    id: "customer_accounts_storefront_display.save_for_later",
    title: "Save for later",
    description:
      "Save for later settings on the Customer accounts storefront display page.",
    productArea: "general",
    access: directMerchantAccess(
      SettingsPermissions.SET_CUSTOMER_ACCOUNTS_SETTINGS,
    ),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: {
      type: "settings",
      path: "customer-accounts-storefront-display",
    },
    synonyms: ["save for later", "customer accounts storefront display"],
  },
  {
    id: "customer_accounts_storefront_display.native_accounts",
    title: "Native accounts",
    description:
      "Native accounts settings on the Customer accounts storefront display page.",
    productArea: "general",
    access: directMerchantAccess(
      SettingsPermissions.SET_CUSTOMER_ACCOUNTS_SETTINGS,
    ),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: {
      type: "settings",
      path: "customer-accounts-storefront-display",
    },
    synonyms: ["native accounts", "customer accounts storefront display"],
  },
] as const satisfies readonly SettingGroupDefinition<CustomerAccountsStorefrontDisplayFlatTeamSettingGroupId>[];

type _assertAllCustomerAccountsStorefrontDisplayFlatTeamSettingGroupsProvided =
  CustomerAccountsStorefrontDisplayFlatTeamSettingGroupId extends (typeof CustomerAccountsStorefrontDisplayFlatTeamSettingGroups)[number]["id"]
    ? true
    : never;
const _allCustomerAccountsStorefrontDisplayFlatTeamSettingGroupsProvided: _assertAllCustomerAccountsStorefrontDisplayFlatTeamSettingGroupsProvided = true;
void _allCustomerAccountsStorefrontDisplayFlatTeamSettingGroupsProvided;

export const CustomerAccountsStorefrontDisplayFlatTeamSettingGroupById: Record<
  CustomerAccountsStorefrontDisplayFlatTeamSettingGroupId,
  SettingGroupDefinition<CustomerAccountsStorefrontDisplayFlatTeamSettingGroupId>
> = (() => {
  const map: Partial<
    Record<
      CustomerAccountsStorefrontDisplayFlatTeamSettingGroupId,
      SettingGroupDefinition<CustomerAccountsStorefrontDisplayFlatTeamSettingGroupId>
    >
  > = {};
  for (const group of CustomerAccountsStorefrontDisplayFlatTeamSettingGroups) {
    map[group.id] = group;
  }
  return map as Record<
    CustomerAccountsStorefrontDisplayFlatTeamSettingGroupId,
    SettingGroupDefinition<CustomerAccountsStorefrontDisplayFlatTeamSettingGroupId>
  >;
})();
